import { Text as T } from '@eo-locale/preact';
import PlusIcon from 'images/icons/Plus.svg';
import { useEffect, useRef } from 'preact/hooks';
import { useState } from 'react';

import { Icon } from 'components/Icon';
import { Stack } from 'components/Stack';
import { Text } from 'components/Text';

import styles from './FileUpload.module.scss';

export function FileUpload() {
  const [isSmall, setIsSmall] = useState(false);
  const nodeRef = useRef<HTMLDivElement>(null);
  const observerRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    observerRef.current = new ResizeObserver((entries) => {
      const [entry] = entries;
      const [size] = entry.contentBoxSize;

      setIsSmall(size.inlineSize < 150);
    });

    const observer = observerRef.current;
    const node = nodeRef.current;

    if (observer && node) {
      observer.observe(node);
    }

    return () => {
      if (observer && node) {
        observer.unobserve(node);
      }
    };
  }, []);

  const contentMarkup = !isSmall ? (
    <Stack vertical spacing="tight">
      <div className={styles.Action}>
        <Text variation="subdued" size="small">
          <T id="write_review_add_images_message" defaultMessage="Add images" />
        </Text>
      </div>
      <Text variation="subdued" size="small">
        <T
          id="write_review_add_images_formats_message"
          defaultMessage="Accepts .jpg, .png, .webp"
        />
      </Text>
    </Stack>
  ) : (
    <Icon source={PlusIcon} color="inherit" />
  );

  return (
    <div ref={nodeRef} className={styles.FileUpload}>
      {contentMarkup}
    </div>
  );
}
